import React from 'react';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import IconPositionEnum from '../../../Enums/IconPositionEnum';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import TpClientPaymentItem from '../../../Domain/TpClientPaymentItem';
import CreateTpPaymentRefundItem from '../../../Domain/CreateTpPaymentRefundItem';
import TpClientPaymentService from '../../../Services/tpClientPaymentService';
import FigmaButtonRow from '../../../Elements/FigmaButtonRow';
import CreateTpClientPaymentItem from '../../../Domain/CreateTpClientPaymentItem';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import CreateTpClientPaymentWindowDescription from './CreateTpClientPaymentWindowDescription';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import CreateTpClientPaymentRefundWindowDescription from './CreateTpClientPaymentRefundWindowDescription';
import ErrorMessage from '../../../Elements/ErrorMessage';
import TpClientPaymentsSearchParams from './TpClientPaymentsSearchParams';
import TpClientPaymentsPrepaymentsSearchParams from './TpClientPaymentsPrepaymentsSearchParams';
import TpClientPaymentPrepaymentItem from '../../../Domain/TpClientPaymentPrepaymentItem';
import TpClientPaymentItemWithoutActions from '../../../Domain/TpClientPaymentItemWithoutActions';

export default class TpClientPaymentsAdmin extends React.Component {
  static defaultProps = {
    type: 'all',
    tpClientInvoiceId: null,
    isOldInvoiceAppliedView: false,
  };

  constructor(props) {
    super(props);

    const searchItem =
      props.type === 'pre-payments'
        ? new TpClientPaymentsPrepaymentsSearchParams()
        : new TpClientPaymentsSearchParams();

    searchItem.PaymentListType = props.type;

    if (this.props.tpClientInvoiceId !== null) {
      searchItem.TpClientInvoiceId = this.props.tpClientInvoiceId;
      searchItem.IsOldInvoiceAppliedSearch = this.props.isOldInvoiceAppliedView;
      searchItem.OfficeIds = [];
    }
    this.state = {
      allItemsInTheSearchSetAreSelected: false,
      itemList: [],
      numberOfElementsInTheTable: 0,
      shownPanel: ShownPanelsEnum.None,
      searchItem,
    };

    this.startSearch = this.startSearch.bind(this);
    this.refresh = this.refresh.bind(this);
    TpClientPaymentItem.refundFunction = this.refundFunction.bind(this);
    TpClientPaymentItem.reverseFunction = this.reverseFunction.bind(this);
    this.callReverseFunction = this.callReverseFunction.bind(this);
    this.openPaymentsApplied = this.openPaymentsApplied.bind(this);
  }

  refresh(refresh) {
    if (refresh) {
      this.setState({ shownPanel: ShownPanelsEnum.None, searchItem: { ...this.state.searchItem } });
    } else this.setState({ shownPanel: ShownPanelsEnum.None });
  }

  renderOnePanel = (panelId, content) => (this.state.shownPanel === panelId ? content : null);

  showPanel(panelId) {
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  componentDidMount() {
    const searchItem = { ...this.state.searchItem };
    searchItem.PaymentListType = this.props.type;
    if (searchItem.PaymentListType !== this.state.searchItem.PaymentListType) this.setState({ searchItem });
  }

  componentDidUpdate() {
    const searchItem = { ...this.state.searchItem };
    searchItem.PaymentListType = this.props.type;
    if (searchItem.PaymentListType !== this.state.searchItem.PaymentListType) this.setState({ searchItem });
  }

  refundFunction(selectedId, paymentItem) {
    const selectedItem = new CreateTpPaymentRefundItem();
    selectedItem.TpClientPaymentId = paymentItem.TpClientPaymentId;
    selectedItem.Amount = paymentItem.Balance;
    this.setState({
      selectedItem,
      shownPanel: ShownPanelsEnum.Refund,
    });
  }

  reverseFunction(selectedId, selectedItem) {
    ErrorMessage.SetWarningWithComment(
      `Reversing a client payment is permanent and cannot be undone. (ID: ${selectedItem.TpClientPaymentId}). Are you sure?`,
      'Comment:',
      (comment) => {
        this.callReverseFunction(selectedItem.TpClientPaymentId, comment);
      },
      'Yes',
      'No'
    );
  }

  callReverseFunction(selectedId, comment) {
    ErrorMessage.SetLoading(true);
    TpClientPaymentService.ReversePayment(selectedId, comment)
      .then((result) => {
        if (result.error) {
          ErrorMessage.SetErrorMessage(result.error);
          return;
        }
        ErrorMessage.SetNotification('Payment reversed.');
        ErrorMessage.SetLoading(false);
        this.refresh(true);
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('TCPA101', error);
        ErrorMessage.SetLoading(false);
      });
  }

  startSearch(searchItem) {
    const newSearchItem = { ...searchItem };
    if (this.props.tpClientInvoiceId) {
      newSearchItem.TpClientInvoiceId = this.props.tpClientInvoiceId;
      newSearchItem.OfficeIds = [];
    }
    this.setState({ searchItem: newSearchItem });
  }

  getPaymentIds() {
    return this.state.itemList
      .filter((x) => x.Selected === true)
      .map((x) => x.TpClientPaymentId)
      .join(',');
  }

  getNumberOfSelectedElements() {
    return this.state.itemList.filter((x) => x.Selected === true).length;
  }

  openPaymentsApplied() {
    window.open(
      `/new_finance_clientpayment/search?PaymentIdsString=${encodeURIComponent(this.getPaymentIds())}&tab=3`,
      '_blank'
    );
  }

  renderButtonsAndPanels() {
    return (
      <div>
        <FigmaButtonRow
          buttons={[
            {
              type: ButtonTypeEnum.ExtraLargeNormal,
              color: ButtonColorsEnum.Common,
              iconPosition: IconPositionEnum.None,
              label: 'Applied Payments Report',
              onClick: this.openPaymentsApplied,
              tooltip: 'Applied Payments Report',
              disabled: this.getNumberOfSelectedElements() === 0,
            },
            {
              type: ButtonTypeEnum.NormalIconOnly,
              color: ButtonColorsEnum.Primary,
              iconPosition: IconPositionEnum.Center,
              iconName: 'fa-solid fa-plus-circle',
              onClick: () => this.setState({ shownPanel: ShownPanelsEnum.AddNewItem }),
              tooltip: 'New Payment',
              roleKey: 'tp_clientpayment_create',
            },
          ]}
        />
        {this.renderPanels()}
      </div>
    );
  }

  renderPanels() {
    return (
      <div>
        {this.renderOnePanel(
          ShownPanelsEnum.AddNewItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={new CreateTpClientPaymentItem()}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={() => this.refresh(true)}
            windowDescription={CreateTpClientPaymentWindowDescription}
            errorCode='TCPA93'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.Refund,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={this.state.selectedItem}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={() => this.refresh(true)}
            windowDescription={CreateTpClientPaymentRefundWindowDescription}
            errorCode='TCPA151'
          />
        )}
      </div>
    );
  }

  render() {
    return (
      <div className='contentwrapper'>
        {!this.props.tpClientInvoiceId && this.renderButtonsAndPanels()}
        <TabOfDataTable
          type={this.getItemType()}
          shownPanel={this.state.shownPanel}
          serviceFunction={TpClientPaymentService.GetPaymentsBySearching}
          convertDBItemsFunction={TpClientPaymentService.ConvertPaymentDBItems}
          searchParamsType={this.getSearchParamsType()}
          showSearchStrip={!this.props.isOldInvoiceAppliedView}
          forceClearCacheOnSearch={this.props.isOldInvoiceAppliedView}
          clickOnStartSearch={this.startSearch}
          searchItem={this.state.searchItem}
          orderBy='EntryDateUtc'
          orderDirection='Desc'
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in client id, payment id, client name or type...'
          errorCode='TCPA180'
          changeOfItemListFunction={(itemList, numberOfElementsInTheTable) =>
            this.setState({ itemList, numberOfElementsInTheTable })
          }
          changeOfAllItemsAreSelectedFunction={(allItemsInTheSearchSetAreSelected) => {
            this.setState({ allItemsInTheSearchSetAreSelected });
          }}
          isSelectAllDisabled={true}
          enableUrlPush={this.props.tpClientInvoiceId === null}
          useClickOnClearAll={this.props.tpClientInvoiceId}
        />
      </div>
    );
  }

  getSearchParamsType() {
    return this.props.type === 'pre-payments' ? TpClientPaymentsPrepaymentsSearchParams : TpClientPaymentsSearchParams;
  }

  getItemType() {
    if (this.props.isOldInvoiceAppliedView) {
      return TpClientPaymentItemWithoutActions;
    }
    return this.props.type === 'pre-payments' ? TpClientPaymentPrepaymentItem : TpClientPaymentItem;
  }
}
